import PrincipeCamps from './PrincipeCamps';

export default PrincipeCamps;
